import { render } from "./Section4View.vue?vue&type=template&id=cab0e00c&scoped=true"
import script from "./Section4View.vue?vue&type=script&lang=js"
export * from "./Section4View.vue?vue&type=script&lang=js"

import "./Section4View.vue?vue&type=style&index=0&id=cab0e00c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cab0e00c"]])

export default __exports__